import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Toolbar from "../Toolbar";
import Sidebar from "../Sidebar";
import Table from "./Table";
import Select from 'react-select';
import countryList from 'react-select-country-list';
import '../../stylesheets/History.css';
import '../../stylesheets/UserManagement.css';
import { HistoryAPI } from "../../axios";

const History = () => {
  const [countries, setCountries] = useState([]);
  const [data, setData] = useState([[], []]);

  useEffect(() => {
    const fullCountryList = countryList().getData().map(country => ({
      label: country.label,
      value: country.label,
    }));
    setCountries(fullCountryList);
  }, []);

  useEffect(() => {
    HistoryAPI.fetch_data_history('Pakistan', '2024-09-02', '2024-08-02')
    .then((res) => {
      setData([res.data.convertedArrayForFirstColumn, res.data.convertedArrayForSecondColumn]);
    })
    .catch((err) => {
      console.error(err);
    });
  }, []);

  const handleSubmit = (values) => {
    HistoryAPI.fetch_data_history(values.location, values.startDate, values.endDate)
    .then((res) => {
      setData([res.data.convertedArrayForFirstColumn, res.data.convertedArrayForSecondColumn]);
    })
    .catch((err) => {
      console.error(err);
    });
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: 'white',
      border: 'none',
      boxShadow: 'none',
      minHeight: 'auto',
      height: '100%',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'gray',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'black',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'white',
      color: 'black',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
      maxHeight: '200px',
      overflowY: 'scroll',
      scrollbarWidth: 'thin',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#ccc' : 'white',
      color: 'black',
      '&:hover': {
        backgroundColor: '#eee',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };
  
  return (
    <div className="main-container">
      <Toolbar />
      <Sidebar />
      <div className="content-container">
        <div className="main-content">
          <div className="management-header">
            <h3> History </h3>
            <Formik
              initialValues={{ location: 'Pakistan', startDate: '2024-09-02', endDate: '2024-08-02' }}
              onSubmit={handleSubmit}
            >
              {({ handleChange, handleBlur, values, setFieldValue, submitForm }) => (
                <Form className="history-form">
                  <div className="history-buttons">
                    <Select
                      name="location"
                      className="history-button"
                      options={countries}
                      onChange={(selectedOption) => {
                        setFieldValue('location', selectedOption.value);
                        submitForm();
                      }}
                      onBlur={handleBlur}
                      value={values.location ? countries.find(option => option.value === values.location) : null}
                      placeholder="Enter location"
                      styles={customStyles} 
                    />
                    <ErrorMessage name="location" component="div" className="error" />
                    <Field
                      name="startDate"
                      type="date"
                      className="history-button"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.startDate}
                    />
                    <ErrorMessage name="startDate" component="div" className="error" />
                    <Field
                      name="endDate"
                      type="date"
                      className="history-button"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.endDate}
                    />
                    <ErrorMessage name="endDate" component="div" className="error" />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div className="center-wrapper">
            <Table data={data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
